<template>
    <div>
        <el-dialog title="新增信控项目" :visible.sync="isControlAdd" center :before-close="onClose" width="1200px" :close-on-click-modal="false">
            <el-row :gutter="20">
                <el-col :span="24">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">
                            <span class="required">*</span>
                            客户名称：
                        </div>
                        <div>
                            <span style="margin-right: 10px; font-size: 12px" v-if="params.Credit_Control_CustomerName">{{ params.Credit_Control_CustomerName }}</span>
                            <el-button type="primary" size="mini" @click="onOpenCustomer()">查询客户</el-button>
                        </div>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">
                            <span class="required">*</span>
                            项目类型：
                        </div>
                        <el-select v-model="params.Credit_Control_Type" placeholder="请选择项目类型" class="el-select-max" value-key="ID" @change="onchangeControlType">
                            <el-option label="请选择项目类型" :value="-1"></el-option>
                            <el-option v-for="item in Control_Typeopt" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">
                            <span class="required">*</span>
                            初始状态：
                        </div>
                        <el-select v-model="params.Credit_Control_State" placeholder="请选择" class="el-select-max" value-key="ID">
                            <template>
                                <el-option v-for="item in Control_Stateopt" :key="item.ID" :label="item.Name" :value="item.ID"></el-option>
                            </template>
                        </el-select>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">
                            <span class="required">*</span>
                            经办人：
                        </div>
                        <el-select v-model="params.Credit_Control_Agent" placeholder="请选择经办人" class="el-select-max" filterable clearable value-key="ID">
                            <el-option v-for="item in Control_Agentopt" :key="item.ID" :label="item.ShowName" :value="item.ID"></el-option>
                        </el-select>
                    </div>
                </el-col>

                <el-col :span="24">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">
                            <span class="required">*</span>
                            包含订单：
                        </div>
                        <div>
                            <el-table :data="creditcontrolorders" border :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                <el-table-column prop="" label="" align="center" width="180">
                                    <template slot="header" slot-scope="{}">
                                        <el-tag size="mini" @click="onOpenorders()">查询</el-tag>
                                    </template>
                                    <template slot-scope="scope">
                                        <el-button size="mini" type="danger" @click="onDelorders(scope.$index, scope.row)">删除</el-button>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Credit_Control_Orders_SN" label="ERP订单号" align="center" width="210"></el-table-column>
                                <el-table-column prop="Credit_Control_Orders_EngineeringName" label="工程名称" show-overflow-tooltip align="center" width="210"></el-table-column>
                                <el-table-column prop="Credit_Control_Orders_MemberName" label="合同签订人" align="center" width="204"></el-table-column>
                                <el-table-column prop="Credit_Control_Orders_RegionCode" label="分支机构" align="center" width="200"></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-col>
                <el-col :span="24" v-if="params.Credit_Control_Type != 3 && params.Credit_Control_Type != 4 && params.Credit_Control_Type != 5 && params.Credit_Control_Type != 6 && params.Credit_Control_Type != 7">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">
                            <span class="required">*</span>
                            承诺还款：
                        </div>
                        <div>
                            <el-table :data="creditcontrolrepayments" border style="width: 100%" :header-cell-style="{ backgroundColor: '#F5F7FA' }">
                                <el-table-column prop="" label="" align="center" width="180">
                                    <template slot="header" slot-scope="{}">
                                        <el-tag size="mini" @click="getOpenTransfermoney()">新增</el-tag>
                                        <!-- <el-button type="text" @click="getOpenTransfermoney()">新增</el-button> -->
                                    </template>
                                    <template slot-scope="scope">
                                        <el-button size="mini" type="danger" @click="onDelpayments(scope.$index, scope.row)">删除</el-button>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="Credit_Control_Repayment_Time" label="还款日期" align="center" width="412"></el-table-column>
                                <el-table-column prop="Credit_Control_Repayment_ReturnMoney" label="还款金额" align="center" width="412"></el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">
                            <span class="required">*</span>
                            项目金额：
                        </div>
                        <div>
                            <el-input v-model="params.Credit_Control_ProjectMoney" clearable class="el-select-max" @input="handleInput($event, 'params', 'Credit_Control_ProjectMoney')"></el-input>
                        </div>
                    </div>
                </el-col>

                <el-col :span="24" v-if="params.Credit_Control_Type == 4 || params.Credit_Control_Type == 5 || params.Credit_Control_Type == 6 || params.Credit_Control_Type == -1">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">发函日期：</div>
                        <div>
                            <el-date-picker v-model="params.LetterTime" class="el-select-max" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" clearable></el-date-picker>
                        </div>
                    </div>
                </el-col>

                <el-col :span="24" v-if="params.Credit_Control_Type == 4 || params.Credit_Control_Type == 5 || params.Credit_Control_Type == 6 || params.Credit_Control_Type == -1">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">快递公司：</div>
                        <div>
                            <el-select v-model="params.Credit_Control_DeliveryName" placeholder="请选择" class="el-select-max" clearable>
                                <el-option v-for="item in Control_DeliveryNameopt" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </div>
                    </div>
                </el-col>
                <el-col :span="24" v-if="params.Credit_Control_Type == 4 || params.Credit_Control_Type == 5 || params.Credit_Control_Type == 6 || params.Credit_Control_Type == -1">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">快递单号：</div>
                        <div>
                            <el-input v-model="params.Credit_Control_DeliveryCode" clearable class="el-select-max"></el-input>
                        </div>
                    </div>
                </el-col>

                <el-col :span="24">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">项目成立日期：</div>
                        <div>
                            <el-date-picker v-model="params.ApplicationTime" class="el-select-max" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" clearable></el-date-picker>
                        </div>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">附件名称：</div>
                        <div>
                            <el-input v-model="params.AttachmentName" :disabled="!params.Credit_Remarks" :placeholder="!params.Credit_Remarks ? '不上传附件可不维护附件名称' : '请输入附件名称'" clearable class="el-select-max"></el-input>
                        </div>
                    </div>
                </el-col>
                <el-col :span="24">
                    <div class="hw-form-item">
                        <div class="hw-form-item-label">附件：</div>
                        <div>
                            <Hwupload ref="Hwupload" v-if="isControlAdd" @onSuccess="onSuccess" @removeFile="removeFile" />
                        </div>
                    </div>
                </el-col>
            </el-row>
            <span slot="footer" class="dialog-footer">
                <el-button @click="onClose()">取 消</el-button>
                <el-button type="primary" @click="onSubmit()">保存</el-button>
            </span>
        </el-dialog>
        <el-dialog title="查找客户" :visible.sync="isShowdialog" width="600px" :before-close="onCloseCustomer" :close-on-click-modal="false">
            <div class="client">
                <div class="client-head">
                    <el-input v-model="Customer_Name" clearable class="el-select-big" placeholder="请数据客户名称全称检索"></el-input>
                    <el-button type="primary" icon="el-icon-search" style="margin-left: 10px" @click="getSelectCreditCustomer()" :loading="isLoading">检索</el-button>
                </div>
                <el-table :data="Customer_list" border :header-cell-style="{ backgroundColor: '#F5F7FA' }" :loading="isLoading">
                    <el-table-column label="客户名称" align="center">
                        <template slot-scope="scope">
                            <el-radio @input="onInputCustomerId($event, scope.row)" v-model="selectedRowId" :label="scope.row.Credit_Customer_ID">{{ scope.row.Credit_Customer_Name }}</el-radio>
                        </template>
                    </el-table-column>
                    <el-table-column prop="Credit_Customer_UniformCode" label="客户编号" align="center"></el-table-column>
                </el-table>
            </div>

            <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center" v-if="selectedRowId">
                <el-button @click="onCloseCustomer()">取消</el-button>
                <el-button type="primary" @click="onSaveCustomerId()">保存</el-button>
            </span>
            <div v-else style="height: 62px"></div>
        </el-dialog>

        <el-dialog title="查找订单" :visible.sync="isShowOrder" width="600px" :before-close="onCloseERPOrders" :close-on-click-modal="false">
            <div class="client">
                <div class="client-head">
                    <el-input v-model="Orders_ERPSN" clearable class="el-select-big" placeholder="ERP订单编号(多个订单号请用英文半角,分割)"></el-input>
                    <el-button type="primary" icon="el-icon-search" style="margin-left: 10px" @click="getCreditERPOrders()" :loading="isLoading">检索</el-button>
                </div>
                <el-table :data="Control_Ordersopt" border :header-cell-style="{ backgroundColor: '#F5F7FA' }" :loading="isLoading">
                    <el-table-column prop="Credit_Control_Orders_SN" label="ERP订单号" align="center" width="120"></el-table-column>
                    <el-table-column prop="Credit_Control_Orders_EngineeringName" label="工程名称" show-overflow-tooltip align="center"></el-table-column>
                    <el-table-column prop="Credit_Control_Orders_MemberName" label="合同签订人" align="center" width="150"></el-table-column>
                    <el-table-column prop="Credit_Control_Orders_RegionCode" label="分支机构" align="center" width="150"></el-table-column>
                </el-table>
            </div>

            <span slot="footer" class="dialog-footer" style="display: flex; justify-content: center" v-if="Control_Ordersopt && Control_Ordersopt.length > 0">
                <el-button @click="onCloseERPOrders()">取消</el-button>
                <el-button type="primary" @click="onSaveERPOrders()">保存</el-button>
            </span>
            <div v-else style="height: 62px"></div>
        </el-dialog>

        <el-dialog title="新增承诺还款" :visible.sync="isTransfermoney" :before-close="onCloserepayment" center width="320px" :close-on-click-modal="false">
            <div class="transfermoney">
                <div class="transfermoney-block">
                    <el-date-picker v-model="repayment.Credit_Control_Repayment_Time" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" clearable></el-date-picker>
                </div>
                <div class="transfermoney-block">
                    <el-input v-model="repayment.Credit_Control_Repayment_ReturnMoney" placeholder="请输入还款金额" @input="handleInput($event, 'repayment', 'Credit_Control_Repayment_ReturnMoney')" clearable></el-input>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="onCloserepayment()">取消</el-button>
                <el-button type="primary" @click="onSaverepayment()">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { cloneDeep, debounce } from 'lodash';
import { toLowerCaseKeys } from '@/utils/utils.js';
import Hwupload from '@/components/Hwupload/index.vue';
export default {
    components: {
        Hwupload
    },
    props: {
        isControlAdd: {
            type: Boolean,
            default: false
        },
        controlprojectList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            isTransfermoney1: true,
            isTransfermoney: false,
            isShowdialog: false,
            isShowOrder: false,
            Customer_Name: '',
            Credit_Control_CustomerName: '',
            Orders_ERPSN: '',
            isLoading: false,
            selectedRowId: null,
            repayment: {
                Credit_Control_Repayment_Time: '',
                Credit_Control_Repayment_ReturnMoney: ''
            },
            params: {
                Credit_Control_CustomerID: '',
                Credit_Control_CustomerName: '',
                Credit_Control_Type: -1,
                Credit_Control_State: '',
                Credit_Control_Agent: '',
                Select_OfficeMember: '',
                Credit_Control_ProjectMoney: '',
                LetterTime: '',
                Credit_Control_DeliveryName: '',
                Credit_Control_DeliveryCode: '',
                ApplicationTime: '',
                Credit_Remarks: '',
                AttachmentName: '',
                action: 'new'
            },
            creditcontrolorders: [],
            creditcontrolrepayments: [],
            Control_Typeopt: [],
            Control_Stateopt: [],
            Control_Agentopt: [],
            Control_DeliveryNameopt: [],
            Control_Ordersopt: [],
            fileList: [],
            Customer_list: []
        };
    },
    watch: {
        isControlAdd(newval) {
            if (newval) {
                this.Control_Typeopt = this.controlprojectList;
                this.getOfficeMemberSelectOption();
                this.getDelivery_Company_Select();
            }
        }
    },
    methods: {
        onSubmit: debounce(function () {
            const params = cloneDeep(this.params);
            params.Credit_Control_State = params.Credit_Control_State || 0;
            params.Credit_Control_Agent = params.Credit_Control_Agent || 0;

            const result = {
                json: JSON.stringify(toLowerCaseKeys(params)),
                creditcontrolorders: this.creditcontrolorders,
                creditcontrolrepayments: this.creditcontrolrepayments
            };
            this.$newsApi.getAddCredit(result).then((res) => {
                if (res.data.Resultcode === 0) {
                    this.$message({
                        message: '操作成功',
                        type: 'success',
                        duration: 2000,
                        onClose: () => {
                            // 这里是提示关闭后的回调函数
                            this.$emit('onClose', true);
                        }
                    });
                }
            });
        }, 800),
        onClose() {
            this.$emit('onClose');
        },
        getSelectCreditCustomer() {
            this.isLoading = true;
            this.$newsApi
                .getSelectCreditCustomer({ Customer_Name: this.Customer_Name })
                .then((res) => {
                    if (res.data.Resultcode === 0) {
                        this.Customer_list = res.data.data;
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        onOpenCustomer() {
            this.Customer_Name = '';
            this.selectedRowId = null;
            this.isShowdialog = true;
            this.Customer_list = [];
        },
        onSaveCustomerId() {
            if (this.selectedRowId) {
                this.params.Credit_Control_CustomerID = this.selectedRowId;
                this.params.Credit_Control_CustomerName = this.Credit_Control_CustomerName;
                this.isShowdialog = false;
            }
        },
        onCloseCustomer() {
            this.isShowdialog = false;
        },
        onInputCustomerId(e, row) {
            this.selectedRowId = row.Credit_Customer_ID;
            this.Credit_Control_CustomerName = row.Credit_Customer_Name;
        },
        onchangeControlType(e) {
            this.Control_Stateopt = [];
            this.params.Credit_Control_State = '';
            this.getCreditState();
        },
        getCreditState() {
            this.$newsApi.getCreditState({ type: this.params.Credit_Control_Type }).then((res) => {
                if (res.data.Resultcode === 0) {
                    this.Control_Stateopt = res.data.data;
                }
            });
        },
        getOpenTransfermoney() {
            this.isTransfermoney = true;
            this.repayment = { Credit_Control_Repayment_ReturnMoney: '', Credit_Control_Repayment_Time: '' };
        },
        onSaverepayment() {
            if (!this.repayment.Credit_Control_Repayment_Time || !this.repayment.Credit_Control_Repayment_ReturnMoney) {
                this.$message({ message: '请输入还款日期和金额！', type: 'warning' });
                return;
            }
            this.creditcontrolrepayments.push({
                ...this.repayment,
                Credit_Control_Repayment_InCompleteMoney: this.repayment.Credit_Control_Repayment_ReturnMoney,
                Credit_Control_Repayment_OverdueReturnMoney: 0,
                Credit_Control_Repayment_AgentRemind: 0,
                Credit_Control_Repayment_CreditID: 0,
                Credit_Control_Repayment_ID: 0
            });
            this.isTransfermoney = false;
        },
        onDelpayments(index) {
            this.creditcontrolrepayments.splice(index, 1);
        },
        onCloserepayment() {
            this.isTransfermoney = false;
        },
        getCreditERPOrders() {
            this.isLoading = true;
            const params = toLowerCaseKeys({ Orders_ERPSN: this.Orders_ERPSN });
            this.$newsApi
                .getCreditERPOrders(params)
                .then((res) => {
                    if (res.data.Resultcode === 0) {
                        this.Control_Ordersopt = res.data.data;
                    }
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        onOpenorders() {
            this.isShowOrder = true;
            this.Orders_ERPSN = '';
            this.Control_Ordersopt = [];
        },
        onDelorders(index) {
            this.creditcontrolorders.splice(index, 1);
        },
        onSaveERPOrders() {
            this.creditcontrolorders.push(...this.Control_Ordersopt);
            this.isShowOrder = false;
        },
        onCloseERPOrders() {
            this.isShowOrder = false;
        },
        getOfficeMemberSelectOption() {
            this.$newsApi.getOfficeMemberSelectOption().then((res) => {
                if (res.data.Resultcode === 0) {
                    this.Control_Agentopt = res.data.data;
                }
            });
        },
        getDelivery_Company_Select() {
            this.$newsApi.getDelivery_Company_Select().then((res) => {
                if (res.data.Resultcode === 0) {
                    this.Control_DeliveryNameopt = Object.entries(res.data.data).map(([key, value]) => ({
                        value: key,
                        label: value
                    }));
                }
            });
        },
        onSuccess(e) {
            this.params.Credit_Remarks = e;
        },
        removeFile() {
            this.params.Credit_Remarks = '';
            this.params.AttachmentName = '';
        },
        handleInput(value, obj, key) {
            const cleanedValue = value.replace(/[^\d.]/g, '');
            const regex = /^\d*\.?\d*$/;
            if (regex.test(cleanedValue)) {
                this[obj][key] = cleanedValue.startsWith('.') ? '0' + cleanedValue : cleanedValue;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.required {
    color: red;
    margin-left: 4px;
}
.hw-form-item {
    padding: 10px 0;
    display: flex;
    align-items: center;

    &-label {
        text-align: right;
        width: 120px;
    }
}

.hw-addcontent-footer {
    margin-top: 20px;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.client {
    margin-bottom: 20px;

    .client-head {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }
}

.transfermoney {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    &-block {
        width: 220px;
        margin-bottom: 20px;

        &:last-child {
            margin-bottom: 0; // No need for 'px' as it's a zero value
        }
    }
}
</style>
